import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useMapContext } from '../MapContext'
import { useAction } from '../../utils/react-redux'
import { selectMapStatus } from '../../../store/map/map.selectors'
import { LAYER_ID_CMM, MAP_STATUS_STYLED } from '../../../store/map/map.constants'
import { navigateTo } from '../../../store/history/history.actions'
import { dispatchTag } from '../../../store/analytics/analytics.actions'
import { TAG_CLICK_MY_MAP } from '../../../store/analytics/analytics.actionTypes'
import { ROUTE_SEO_GEOENTITY } from '../../../routes'
import { resetGeoentities } from '../../../store/geoentity/geoentity.actions'
import { selectIsFrenchSite } from '../../../store/locale/locale.selectors'

const useClickMyMapLayers = () => {
  const { map } = useMapContext()
  const status = useSelector(selectMapStatus)
  const execNavigateTo = useAction(navigateTo)
  const execDispatchTag = useAction(dispatchTag)
  const execResetGeoentities = useAction(resetGeoentities)
  const isFrenchSite = useSelector(selectIsFrenchSite)

  const navigateToPoi = ({ id, rubricId }) => {
    execDispatchTag({
      type: TAG_CLICK_MY_MAP,
      tagInfo: {
        catId: rubricId
      }
    })

    execResetGeoentities()
    execNavigateTo({
      route: ROUTE_SEO_GEOENTITY,
      routeOptions: { geoentityId: id }
    })
  }

  const onClick = e => {
    const id = e.features[0].properties.mappy_poi_id
    const rubricId = e.features[0].properties.mappy_context_rubric

    navigateToPoi({ id, rubricId })
  }

  useEffect(() => {
    if (!map || status !== MAP_STATUS_STYLED) return

    map
      .getStyle()
      .layers.filter(layer => layer.layout && layer.layout.visibility)
      .forEach(({ id }) => {
        if (id.match(LAYER_ID_CMM)) {
          map.setLayoutProperty(id, 'visibility', 'visible')
          if (isFrenchSite) {
            map.on('click', id, onClick)
          }
        }
      })

    return () => {
      if (map && map.getStyle())
        map
          .getStyle()
          .layers.filter(layer => layer.layout && layer.layout.visibility)
          .forEach(({ id }) => {
            if (isFrenchSite) {
              map.off('click', id, onClick)
            }
          })
    }
  }, [map, status, isFrenchSite])
}

export default useClickMyMapLayers
